
import React from 'react';
import { Container, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import ProductModalList from "./Common/ProductModalList";
import './LoanProtectionAbout.scss';

const useStyles = makeStyles(theme => ({
  textcolor: {
    color: theme.palette.primary.main,
  }
}));

export default function About({data, carriers}) {
  const classes = useStyles();

  function buildList(list, index) {
    return (
      <ul key={index} className="specification-list">
        {list.map((listItem, i) => Array.isArray(listItem) ?
          buildList(listItem, i) :
          <li key={i}>{listItem}</li>
        )}
      </ul>
    );
  };

  return (
    <Container fluid className='loan-protection-about' id="loan-protection-about">
      <Row className="justify-content-center">
        <h2 className="text-center about-title mb-3">{data.title}</h2>
      </Row>
      <Row className="justify-content-center">
        <p className='about-content'>{data.content}</p>
      </Row>
      {data.productData && <Row className="specification main-content">
        <ExpansionPanel className='expansion-panel '>
        <ExpansionPanelSummary
            expandIcon={<KeyboardArrowDownIcon color="primary" />}
            aria-controls="panel1-content"
            className="py-2 px-0"
            role=""
          >
          <div className={`specification ${classes.textcolor}`}>PRODUCT SPECIFICATIONS</div>
          </ExpansionPanelSummary>
           <ExpansionPanelDetails className="pb-3 px-0 pt-0">
            {data.productData.map((d, index) =>
              <div key={index}>
                <h3 className="specification-title">{d.title}</h3>

                {Array.isArray(d.text)
                  ? buildList(d.text, index)
                  : <p className="specification-content">{d.text}</p>}
              </div>
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Row>}
      {data.productModalData && <ProductModalList data={data.productModalData} carriers={carriers}/>}
    </Container>
  );
};

About.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/LandingPages/About/LoanProtectionAbout.js